import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DashValidation,
  isEmailValid,
  isEmptyOrNil,
  isNameLengthValid,
} from 'dash-common';
import {
  FormContext,
  FormErrorTypes,
  IPriceRangeMax,
  IPriceRangeMin,
  validatePrice,
} from 'dash-ui';

import { FormFields } from '../SaveSaleTeamUserModal.constants';

const useValidation = () => {
  const { formState, errorHandlers } = useContext(FormContext);
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { min, max } = formState;

  const validateFieldByName = useCallback(
    (
      fieldName: FormFields,
      value: string | IPriceRangeMax | IPriceRangeMin
    ) => {
      const setInvalid = (message: string, values?: Record<string, string>) => {
        errorHandlers[fieldName]({
          type: FormErrorTypes.Invalid,
          message: t(message, values || {}),
        });
      };

      // check specific fields type
      switch (fieldName) {
        case FormFields.FirstName:
        case FormFields.LastName: {
          if (isEmptyOrNil(value as string)) {
            setInvalid('forms:messages.nameBlank');
            return false;
          }
          if (!isNameLengthValid(value as string)) {
            setInvalid('forms:messages.maxCharacterLimit', {
              number: DashValidation.MaxNameLength.toString(),
            });
            return false;
          }
          break;
        }
        case FormFields.Email: {
          if (isEmptyOrNil(value as string)) {
            setInvalid('forms:messages.emailRequired');
            return false;
          }
          if (!isEmailValid(value as string)) {
            setInvalid('forms:messages.emailInvalid');
            return false;
          }
          break;
        }
        case FormFields.Role: {
          if (isEmptyOrNil(value as string)) {
            setInvalid('forms:messages.roleRequired');
            return false;
          }
          break;
        }
      }
      errorHandlers[fieldName](null);
      return true;
    },
    [min, max, t, errorHandlers]
  );

  return validateFieldByName;
};

export default useValidation;
